module.exports = __webpack_public_path__ + "static/media/HeroCookies.2596b29a.jpg";